import Main from './SubscribeMain'
import Checkout from './SubscribeCheckout'

export default {
  Main,
  Checkout,
}
